import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1 8.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 5 3.08 5 4.2 5h15.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C23 6.52 23 7.08 23 8.2V13H1V8.2ZM8 8H3v3h5V8Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M1 15h22v.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C21.48 19 20.92 19 19.8 19H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 17.48 1 16.92 1 15.8V15Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }